import { render } from "./MbWay.vue?vue&type=template&id=2a328dda&scoped=true"
import script from "./MbWay.vue?vue&type=script&lang=js"
export * from "./MbWay.vue?vue&type=script&lang=js"

import "./MbWay.vue?vue&type=style&index=0&id=2a328dda&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a328dda"]])

export default __exports__